import { formatCurrency, formatDecimal, formatUnit } from "@/common/utils/formatters";
import CompanyConsumptionDetails from "@/features/privateCompanies/components/companyConsumptionDetails";
import CompanyRefundDetails from "@/features/privateCompanies/components/companyRefundDetails";
import React from "react";

export class ProductsSummaryTransformer {
  static tableTransformer() {
    return (products: any[]) => {
      return products.map((product) => {
        return {
          ...product,
          total_consumptions_count: Number(product.total_consumptions_count || 0),
          total_quantity: formatUnit(formatDecimal(product.total_quantity), product.unit_for_quantity),
          total_amount: formatCurrency(Number(product.total_amount) || 0),
        };
      });
    };
  }
}

export const eventableDetailsComponent: { [key: string]: React.ComponentType<any>; } = {
  'Client::Consumption': CompanyConsumptionDetails,
  'Billing::Refund': CompanyRefundDetails,
};
